(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceTimeSessionCustom', ServiceTimeSessionCustom);

    ServiceTimeSessionCustom.$inject = ['$resource'];

    function ServiceTimeSessionCustom($resource) {


        var getServiceTimeSessionFromNow = function (serviceItemId) {
            //
            var resourceUrl = 'api/get-service-time-sessions-from-now?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServiceTimeSessionInOneDate = function (serviceItemId, dateTime) {
            //
            var resourceUrl = 'api/get-service-time-sessions-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTime;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAvailableServiceTimeSessionsInOneDate = function (serviceItemId, dateTime) {
            //
            var resourceUrl = 'api/get-available-service-time-sessions-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTime;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getServiceTimeSessionFromNow: getServiceTimeSessionFromNow,
            getServiceTimeSessionInOneDate: getServiceTimeSessionInOneDate,
            getAvailableServiceTimeSessionsInOneDate: getAvailableServiceTimeSessionsInOneDate
        };
    }
})();
